export const TemplateType = {
    EXISTING_TEMPLATE: 'Existing Template',
    NEW_TEMPLATE: 'New Template (From Master)',
    TRANSLATION_KEY: 'Translation Key',
}


// WEBPACK FOOTER //
// ./src/app/shared/constants/templateType.constants.ts